<template>
  <v-content>
    <v-container
    >
      <v-layout 
        align-center 
        justify-center>
        <v-flex xs12
          sm4
          align-center >
          <img
            src="/img/logo-login.png"
            class="logo"
          />       
        </v-flex>
      </v-layout>
      <v-layout
        flex
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm5
        >
          <v-card class="login-box">
            <v-card-text class="pt-4">
              <v-toolbar-title >
                <h2>Request a New Account</h2>
              </v-toolbar-title>
              <span v-if=showMessageSuccess>{{message}}</span>
              <div>
                <ValidationObserver ref="observer" tag="form" @submit.prevent="signin">
                  <div v-if=!showMessageSuccess>
                    <v-layout>
                      <v-flex xs6>
                        <ValidationProvider rules="required|min:1|max:50" v-slot="{ errors, valid }" name='name'>
                          <v-text-field
                            label="First Name"
                            v-model="form.firstname"
                            data-vv-name="firstname"
                            data-vv-validate-on="none"
                            required
                            class="input"
                            :success="valid"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-flex>
                      <v-flex xs6>
                        <ValidationProvider rules="required|min:1|max:50" v-slot="{ errors, valid }" name='lastname'>
                          <v-text-field
                            label="Last Name"
                            v-model="form.lastname"
                            data-vv-name="lastname"
                            data-vv-validate-on="none"
                            required
                            class="input"
                            :success="valid"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-flex>
                    </v-layout>
                    <ValidationProvider rules="required|email|min:5|max:50" v-slot="{ errors, valid }" name='email'>
                      <v-text-field
                        label="Email"
                        v-model="form.email"
                        data-vv-name="email"
                        data-vv-validate-on="none"
                        required
                        class="input"
                        :success="valid"
                        :error-messages="errors"
                        v-if=!showMessageSuccess
                      />
                    </ValidationProvider>
                    <ValidationProvider rules="required|min:6|max:20" v-slot="{ errors, valid }" name='password'>                    
                      <v-text-field
                      label="Password"
                      v-model="form.password"
                      data-vv-name="password"
                      data-vv-validate-on="none"
                      required
                      autocomplete="false"
                      class="input"
                      :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                      @click:append="() => (hidePassword = !hidePassword)"
                      :type="hidePassword ? 'password' : 'text'"                    
                      :success="valid"
                      :error-messages="errors"
                      />
                    </ValidationProvider>
                    <ValidationProvider rules="required|confirmPassword:@password" v-slot="{ errors, valid }" name='password_confirmation'>
                      <v-text-field
                        label="Confirm password"
                        v-model="form.password_confirmation"
                        data-vv-name="password_confirmation"
                        data-vv-validate-on="none"
                        autocomplete="false"
                        :append-icon="hidePassword2 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (hidePassword2 = !hidePassword2)"
                        :type="hidePassword2 ? 'password' : 'text'"
                        :success="valid"
                        :error-messages="errors"
                      ></v-text-field>                    
                    </ValidationProvider>
                  </div>
                  <v-layout wrapper-button class="mt-2" >
                    <v-btn 
                      type="submit" 
                      outlined 
                      color="primary"
                      v-if=!showMessageSuccess>  
                      Sign In
                    </v-btn>
                    <v-btn type="submit" text color="primary" :to="{name : 'login'}">
                      Back to Log in
                    </v-btn>
                  </v-layout>
                </ValidationObserver>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="showResult"
      :timeout="2000"
      top
    >{{ result }}</v-snackbar>
  </v-content>
</template>

<script>
import AppConfig from '@/config/appConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import validations from '@/modules/validations'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      showMessageSuccess:false,
      hidePassword: true,
      hidePassword2: true,
      message:'We are processing your request, you will soon receive an activation email.',
      form: {
        role_code: '',
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        app: AppConfig.appName,
        authentication_type:'email',
      },
      showResult: false,
      result: null,
      appLogo: AppConfig.appLogo2
    }
  },
  methods: {
    signin () {
      
      const vm = this
      vm.$refs.observer.validate().then(valid => {
        if (valid) {
          vm.$store.dispatch('createAccount', {
            credentials: vm.form
          }).catch(() => {
            vm.loading = false         
            this.showMessageSuccess=false
          })
          .then(
            this.showMessageSuccess=true
          )
        }
      })
    }
  }
}
</script>
<style scoped>
  .v-toolbar__title {
    width: 100%;
  }
  h2 {
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: left;
    color: black;
  }
  h5 {
    font-weight: 400;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: left;
    color: black;
  }
  .login-box {
    border: 2px solid #244AB3;
    border-radius: 10% !important;
    min-height: 350px;
    min-width: 450px;
  }
  .logo {          
    left: 40px;
  }
  .btn-login {
    background-color: #244AB3 !important;
    border-color: #244AB3 !important;
    border-radius: 45px;
    min-height: 48px;
    color: #244AB3;
  }
  .v-btn{
    text-transform: none !important;
  }
  .pt-4 {
    padding-top: 20px !important;
  }
  .wrapper-button {
    display: -webkit-box;
  }
  .v-btn {
    margin: 0 auto;
    display: flex;
  }
</style>
